const TWEMOJI_VERSION = '17.0.3';
const TWEMOJI_SCRIPT_URL = `https://cdn.jsdelivr.net/npm/@twemoji/api@${TWEMOJI_VERSION}/dist/twemoji.min.js`;
const TWEMOJI_ASSET_BASE = `https://cdn.jsdelivr.net/gh/jdecked/twemoji@${TWEMOJI_VERSION}/assets/`;
let twemojiPromise;
const emojiObservers = new WeakMap();

const loadTwemoji = () => {
  if (window.twemoji) return Promise.resolve(window.twemoji);

  if (!twemojiPromise) {
    twemojiPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = TWEMOJI_SCRIPT_URL;
      script.onload = () => resolve(window.twemoji);
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  return twemojiPromise;
};

const parseEmoji = (element, twemoji, { loading, singleMessage }) => {
  twemoji.parse(element, {
    base: TWEMOJI_ASSET_BASE,
    folder: 'svg',
    ext: '.svg',
    className: 'cw-emoji inline-block h-[1em] w-[1em] align-[-0.125em]',
    attributes: () => ({ loading, decoding: 'async' }),
  });

  const emojis = [...element.querySelectorAll('.cw-emoji')];
  emojis
    .slice(0, -1)
    .forEach(emoji => emoji.classList.add('cw-emoji--with-gap'));

  if (singleMessage && emojis.length === 1 && !element.textContent.trim()) {
    emojis[0].classList.add('cw-emoji--single-message');
  }
};

const renderEmojiNow = (element, options) => {
  loadTwemoji()
    .then(twemoji => parseEmoji(element, twemoji, options))
    .catch(() => {});
};

export const renderEmoji = (
  element,
  { loading = 'lazy', singleMessage = false } = {}
) => {
  if (!element) return;

  emojiObservers.get(element)?.disconnect();

  const options = { loading, singleMessage };
  if (
    element.classList.contains('emoji--item') &&
    typeof IntersectionObserver !== 'undefined'
  ) {
    const observer = new IntersectionObserver(
      entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;

        observer.disconnect();
        emojiObservers.delete(element);
        renderEmojiNow(element, options);
      },
      {
        root: element.closest('.emoji-item'),
        rootMargin: '120px',
      }
    );

    emojiObservers.set(element, observer);
    observer.observe(element);
    return;
  }

  renderEmojiNow(element, options);
};

export const twemojiDirective = {
  mounted: (element, binding) => renderEmoji(element, binding.value),
  updated: (element, binding) => renderEmoji(element, binding.value),
  unmounted: element => {
    emojiObservers.get(element)?.disconnect();
    emojiObservers.delete(element);
  },
};
